import Resize from './Resize'
import { useColumnWidths } from './utils/TableStore/ResizeContext'
import type { ColumnWidth } from './utils/calculateColumnWidths'
import type { FC, ReactNode } from 'react'

export default function WithResize<P extends Partial<ColumnWidth> & { children?: ReactNode; className?: string }>(
  Component: FC<P>
) {
  return function CellWithResizeData({
    colIndex,
    children,
    firstRow,
    ...props
  }: Omit<P, keyof ColumnWidth> & { colIndex: number; firstRow?: boolean; className?: string }) {
    const { resizable, ...widths } = useColumnWidths(colIndex)
    const props_ = { ...props, ...widths } as unknown as P
    return (
      <Component {...props_}>
        {children}
        {resizable && firstRow && <Resize index={colIndex} />}
      </Component>
    )
  }
}
